import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useQueryClient} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import type {KilnReplacement} from '../../types'
import {useRefraPlanningTracking} from '../tracking'

import {mutations} from '@refra/api/mutations'
import {useRefraMutation} from '@refra/modules/common/hooks'
import {useRefraModal} from '@refra/modules/common/providers'
import {logger} from '@refra/modules/common/utils'

export const useDeleteMaterialInstallation = () => {
  const {t} = useTranslation()
  const queryClient = useQueryClient()
  const {closeModal} = useRefraModal()
  const tracking = useRefraPlanningTracking()

  return useRefraMutation({
    mutationFn: mutations.deleteMaterialInstallation,
    onError: (error) => {
      const errorDetails = error?.response?.data.detail ?? error.message ?? error.response?.status
      logger
        .context('useDeleteMaterialInstallation')
        .extras({errorDetails})
        .error('Error occurred while deleting a material installation')

      spawnErrorToast(t('error.deleteMaterialInstallation'))
    },
    onSuccess: (_, {plantUpmId, kilnUpmId, shutdownId, installationId}) => {
      tracking.materialInstallation.remove(installationId)

      queryClient.setQueryData(
        [
          'kilnReplacement',
          {
            plantUpmId,
            kilnUpmId,
            shutdownId
          }
        ],
        (kilnReplacement: KilnReplacement) => {
          return {
            ...kilnReplacement,
            materialInstallations: kilnReplacement.materialInstallations.filter(
              (installation) => installation.id !== installationId
            )
          }
        }
      )
      spawnSuccessToast(t('success.deleteMaterialInstallation'))
    },
    onSettled: () => closeModal()
  })
}
